/** Highlights in the outcome texts (`<bold>`, `<boldError>`, …). */
export const resultTextComponents = {
  bold: <span className="font-semibold text-vm-green-text" />,
  boldError: <span className="font-semibold text-vm-red-text" />,
  boldSuccess: <span className="font-semibold text-vm-green-text" />,
}
